export type MutationErrorExtensionsCCGraphql<TExtension> = {
	__typename?: 'MutationError';
	message: string | null | undefined;
	extensions: TExtension[] | null | undefined;
};
export type MutationErrorExtensionsAgg<TExtension> = {
	__typename?: 'MutationError';
	message: string | null | undefined;
	extensions: TExtension | null | undefined;
};

export function mutationErrorExtensionsAggCompat<
	TExtension,
	TError extends MutationErrorExtensionsAgg<TExtension>,
>(mutationErrors: readonly TError[]): (TError & MutationErrorExtensionsCCGraphql<TExtension>)[] {
	return mutationErrors.map((e) => ({
		...e,
		// The Array check normalizes the fact that the GraphQL schema
		// can differ at __runtime__ between AGG and cc-graphql.
		extensions: Array.isArray(e.extensions)
			? e.extensions
			: e.extensions != null
				? [e.extensions]
				: undefined,
	}));
}
